import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import ToggleSwitch from "../ToggleSwitch";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { authServices } from "Utils/auth/services";
import snackbarUtil from "Utils/snackBarUtil";

interface PermissionModalProps {
  show: any;
  userIds: string;
  userName: string;
  getUserList: () => Promise<void>;
  setTelegramEnabled: Dispatch<SetStateAction<boolean>>;
  enableTelegram: number;
}

const TelegramEnable = ({
  show,
  userName,
  getUserList,
  setTelegramEnabled,
  userIds,
  enableTelegram,
}: PermissionModalProps) => {
  const [permissionData, setPermissionData] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [passVal, setPasswordVal] = useState<string>("");
  const [errors, setErrors] = useState<{ password?: string }>({});

  useEffect(() => {
    setPermissionData(enableTelegram ? true : false);
  }, [enableTelegram]);

  const validateForm = () => {
    let formErrors: { password?: string } = {};
    if (!passVal || passVal.trim().length < 6) {
      formErrors.password = "Password must be at least 6 characters.";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const getEnabledTelegram = async (
    is_enable_telegram_default: number,
    password: string
  ) => {
    const { response } = await authServices.getEnabledTelegram({
      user_id: userIds,
      is_enable_telegram_default,
      password,
    });
    if (response?.status) {
      snackbarUtil.success(response?.msg);
      setTelegramEnabled(false);
      await getUserList(); // Refresh user list
    } else {
      snackbarUtil.error(response?.msg || "Something went wrong.");
    }
  };

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPermissionData(event.target.checked);
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    getEnabledTelegram(permissionData ? 1 : 0, passVal);
  };

  return (
    <Modal
      show={show}
      onHide={() => setTelegramEnabled(false)}
      className="zoomIn"
      scrollable
    >
      <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
        <span>Telegram Setting of {userName}</span>
        <Button
          variant="light btn-sm"
          onClick={() => setTelegramEnabled(false)}
        >
          <i className="ri-close-line fs-xl align-middle"></i>
        </Button>
      </Modal.Header>

      <Modal.Body className="fs-md">
        <Row className="gap-3">
          <Col sm={12}>
            <p>Current Status: {permissionData ? "Enabled" : "Disabled"}</p>
            <div className="d-flex align-items-center mb-3">
              <Form.Label
                className="form-check-label ms-2"
                htmlFor="MultiLogin"
              >
                Update
              </Form.Label>
              <ToggleSwitch
                checked={permissionData}
                id="MultiLogin"
                onChange={handleToggle}
              />
            </div>

            <Form.Group controlId="formPassword">
              <Form.Label>Enter Logged In Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  value={passVal}
                  onChange={(e) => setPasswordVal(e.target.value)}
                  isInvalid={!!errors.password}
                />
                <Button
                  variant="link"
                  className="position-absolute end-0 top-0 bottom-0 text-decoration-none text-muted password-addon"
                  type="button"
                  id="password-addon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`${
                      showPassword ? "ri-eye-fill" : "ri-eye-off-fill"
                    } align-middle`}
                  ></i>
                </Button>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="border-top">
        <Button variant="light" onClick={() => setTelegramEnabled(false)}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TelegramEnable;
